import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { OverlayTrigger, Tooltip, Row, Col, Button, Modal } from "react-bootstrap";
import { FiEye, FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import { getAllEvents } from "app/_services/ehs/ehsEventServices";
import { UserService } from "app/_services/UserService/UserService";
import SelectSearch from "app/Components/SearchableSelect/Select";
import { Validation } from "app/_helpers/validation/Validation";
import { getAllMeetingGroups } from "app/_services/ehs/ehsMeetingGroupServices";
import {
  getAllEventSchedules,
  createEventSchedule,
  getEventScheduleById,
  updateEventSchedule,
} from "app/_services/ehs/ehsEventScheduleServices";
import Decline from "../IncidentManagement/DeclinePopup";
import {
  initialForm,
  MeetingApprover,
  MeetingReviewer,
  MeetingScheduler,
  MEETING_STATUS,
} from "./CONSTANT";
import { employeeDropdownLabel, normalizeDateTime } from "app/_helpers/helper";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import SingleFileUpload from "app/views/custom/components/FileUpload/SingleFileUpload";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { getAllContractorPerson } from "app/_services/UserManagement/ContractorPersonService";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FaCheck, FaInfo } from "react-icons/fa";
import ViewComments from "../IncidentManagement/ViewComments";
import InputError from "app/Components/_form/InputError/InputError";
import {
  IS_USER_SITE_MINES,
  LOGGED_IN_USER_EMPLOYEE_ID,
  LOGGED_IN_USER_SITE_ID,
} from "../IncidentManagement/Helper";
import RichTextarea from "app/Components/RichTextarea/RichTextarea";
import { Link } from "react-router-dom";
import { disable12MonthAfterFutureDate } from "app/_helpers/dateHelper";
import {
  useContractorPersonDropdown,
  useEmployee,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import OverFlowLabel from "app/Components/UI/OverFlowLabel/OverFlowLabel";
import moment from "moment";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const initialParticipant = {
  category: "",
  name: "",
  email: "",
  userId: null,
};

const AddUpdateMeeting = ({
  match: {
    params: { id, eventId, siteId },
  },
  history,
}) => {
  const [form, setForm] = useState({ ...initialForm, siteId: siteId || "" });
  const [errorForm, setErrorForm] = useState({ ...initialForm });
  const [events, setEvents] = useState([]);
  const [users, setUsers] = useState([]);
  const [sites, setSites] = useState([]);
  const [groupParticipants, setGroupParticipants] = useState([]);
  const [meetingGroups, setMeetingGroups] = useState([]);
  const [getSchedule, setGetSchedule] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [participantsErrors, setParticipantsErrors] = useState([]);
  const [witnessStatements, setWitnessStatements] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  /****** Custom Hook****/
  const [employees, employeesOption] = useEmployeeDropdown();
  const [contractorPersons, contractorPersonsOption] = useContractorPersonDropdown();

  const onChange = ({ target: { name, type, checked, value } }) =>
    setForm((prev) => ({
      ...prev,
      eventId: name === "type" ? "" : prev.eventId,
      [name]: type === "checkbox" ? checked : value,
    }));

  const onChangeSite = ({ target: { site } }) => {
    setForm((prev) => ({ ...prev, siteId: site.id, site }));
  };

  const onChangeParticipant = ({ target: { name, value } }, index) =>
    setParticipants((prev) =>
      prev.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = value;

        if (name === "category") {
          data.userId = null;
          data.name = "";
          data.email = "";
        }

        return data;
      })
    );

  const onChangeParticipantName = ({ target: { name, email, userId } }, index) =>
    setParticipants((prev) =>
      prev.map((data, idx) => (idx !== index ? data : { ...data, name, email, userId }))
    );

  const addRow = () => setParticipants((prev) => [...prev, { ...initialParticipant }]);
  const deleteRow = (index) =>
    setParticipants((prev) => {
      if (prev[index].id) {
        if (id && +prev[index].userId === +form.ownerId) {
          toastr.warning("Please change owner before deleting from participants!");
          return prev;
        }
        prev[index].deleted = 1;
      } else prev.splice(index, 1);

      return [...prev];
    });

  const onSubmit = async (submitStatus, obj) => {
    if (submitted) return;
    let flag = 0;
    let errorObj = Validation(form, rules);

    if (
      form?.id &&
      !form.reviewCompletionSummary &&
      form?.eventStatus !== MEETING_STATUS.draft &&
      submitStatus !== null &&
      submitStatus !== "backward"
    ) {
      errorObj.reviewCompletionSummary = "Message is Required";
    }

    const errorArray = participants.map((user) =>
      user.deleted ? {} : Validation(user, userRules)
    );

    if (!id) {
      for (let i = 0; i < participants.length; i++) {
        if (
          groupParticipants.find(
            (user) => user.email.toLowerCase() === participants[i].email.toLowerCase()
          )
        )
          errorArray[i].email = "Duplicate Entry!";
      }
    }

    // if (obj) {
    //   formData.isBack = 1;
    //   formData.comment = obj.comment;

    // }
    const formData = {
      ...form,
      participants: [...participants],
      moveMeeting: submitStatus,
      comment: obj?.comment,
      reviewCompletionSummary: form.reviewCompletionSummary,
    };
    if (!id)
      formData.participants.splice(
        formData.participants.length,
        0,
        ...groupParticipants.map((p) => ({ ...p, id: undefined }))
      );
    if (!formData.participants.length)
      errorObj.meetingGroupIds = "Minimum 1 Participant is required.";

    // if (!formData.participants.find((p) => +p.userId === +form.ownerId)) {
    //   const owner = users.find((user) => user.id === +form.ownerId);
    //   if (owner)
    //     formData.participants.push({
    //       category: "Employee",
    //       name: `${owner.firstName} ${owner.lastName}`,
    //       email: owner.email,
    //       userId: owner.id,
    //     });
    // }
    setErrorForm(errorObj);
    setParticipantsErrors(errorArray);

    // console.log("errorObj", errorObj);

    for (const key in errorObj) if (errorObj[key]) flag = 1;
    for (const obj of errorArray) for (const key in obj) if (obj[key]) flag = 1;

    if (flag !== 0) return;

    // console.log("flaggg", formData);
    // return;

    setLoading(true);
    const response = id
      ? await updateEventSchedule(id, formData)
      : await createEventSchedule(formData);
    setSubmitted(true);
    setLoading(false);

    if (!response?.status) {
      setSubmitted(false);
      return toastr.error(response?.message);
    }

    toastr.success(response?.message || "Success.");

    history.push(
      (siteId ? `/sites/${siteId}` : "") +
        "/health-safety-and-environment/audits-meetings"
    );
  };

  useEffect(() => {
    if (!siteId || !sites.length) return;

    const site = sites.find((site) => site.id === +siteId);
    if (site) setForm((prev) => ({ ...prev, site }));
  }, [sites, siteId]);

  useEffect(() => {
    const users = [];

    form.meetingGroupIds.forEach((id) => {
      const group = meetingGroups.find((g) => g.id === +id);
      if (!group) return;
      group.participants.forEach((user) => {
        if (!users.find((u) => u.userId === user.userId)) users.push(user);
      });
    });

    setGroupParticipants(users);
  }, [meetingGroups, form.meetingGroupIds]);

  useEffect(() => {
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setUsers(response.data);
    });
    getAllMeetingGroups("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setMeetingGroups(
        response.data.map((group) => ({
          ...group,
          participants: group.participants.map((participant) => ({
            ...participant,
            email: participant.user?.email || participant.email,
            name: participant.user
              ? `${participant.user.firstName} ${participant.user.lastName}`
              : participant.name,
          })),
        }))
      );
    });

    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;
      setSites(response.data);
    });
  }, []);

  useEffect(() => {
    setForm((prev) => ({ ...prev, participants: participants }));
  }, [participants]);

  useEffect(() => {
    getAllEventSchedules().then((response) => {
      console.log("response", response);
      setGetSchedule(
        response?.data?.filter((d) => d.siteId === LOGGED_IN_USER_SITE_ID())
      );
    });
  }, [eventId]);

  useEffect(() => {
    getAllEvents("filter[status]=1").then((response) => {
      setEvents(response?.data);
    });
  }, []);

  useEffect(() => {
    const event = events?.find((event) => event.id == eventId);

    if (event) {
      setForm((prev) => ({
        ...prev,
        eventId,
        type: event.id,
        approver: event?.approver,
        meetingLabel: event?.meetingLabel,
        scheduler: event?.scheduler,
        reviewer: event?.reviewer,
        meetingID: event?.id,
        name: event?.name,
      }));
    }
  }, [events]);

  useEffect(() => {
    if (!id) return;

    getEventScheduleById(id).then((response) => {
      if (!response?.data) return;
      setForm({
        ...response.data,
        refDocumentDescription: response?.data.refDocumentDescription || "",
        remarks: response?.data.remarks || "",
        date: normalizeDateTime(response.data.date),
      });
      setParticipants(response.data.participants);
    });
  }, [id]);

  const onChangeFile = async (responseData, index) => {
    if (typeof index !== "number")
      setForm((prevForm) => ({
        ...prevForm,
        refDocumentId: responseData.id,
        insuranceFile: responseData,
      }));
    else
      setWitnessStatements((previous) =>
        previous.map((data, idx) => {
          if (idx !== index) return data;
          data.fileId = responseData.id;
          data.file = responseData;

          return data;
        })
      );
  };

  const onDeleteFile = async (index) => {
    if (typeof index !== "number")
      setForm((prevForm) => ({
        ...prevForm,
        insuranceFileId: null,
        insuranceFile: null,
      }));
    else
      setWitnessStatements((previous) =>
        previous.map((data, idx) => {
          if (idx !== index) return data;
          data.fileId = null;
          data.file = null;

          return data;
        })
      );
  };

  let holdIndex;

  const onChangeDate = (momentDate, name) => {
    if (typeof momentDate === "string") return;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: momentDate.format("YYYY-MM-DD HH:mm:ss"),
    }));
  };

  useLayoutEffect(() => {
    const site = sites?.find((d) => +d.id === +LOGGED_IN_USER_SITE_ID());
    setForm((prev) => {
      const obj = site
        ? {
            siteId: site?.id,
            siteName: site?.name,
            // stateMasterId: sites[0]?.state.id,
            // countryMasterId: sites[0]?.state.country_master?.id,
            // locationSiteId: sites[0]?.siteId,
            // roId: sites[0]?.parentSite?.id,
            // roName: sites[0]?.parentSite?.name,
            // roSiteId: sites[0]?.parentSite?.siteId,
            site: site,
          }
        : {};
      return { ...prev, ...obj };
    });
  }, [sites]);

  const previousMeeting = useMemo(
    () => getSchedule?.find((d) => d.id === form?.previousMeetingID),
    [form?.previousMeetingID, getSchedule]
  );
  const formDisabled = useMemo(
    () => form?.eventStatus === MEETING_STATUS.planned,
    [form?.eventStatus]
  );

  // console.log("form", form);

  // console.log("getSchedule", getSchedule);
  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          {
            name: "Schedule Event",
            path: "/health-safety-and-environment/audits-meetings/scheduled-event",
          },
          {
            name: "Schedule A Meeting",
          },
        ]}
      />
      {/* <Breadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE",
            path:
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/audits-meetings/manage-events",
          },
          { name: id ? "Edit Scheduled Meeting" : "Schedule Meeting" },
        ]}
      /> */}

      <div className="card p-3 mt-4">
        <div className="simple-card-title d-flex justify-content-between ">
          <h3 class="text-capitalize mb-0">Schedule a Meeting</h3>
          <span className="mr-3">
            Meeting Type: <b>{form?.event?.name || form?.name}</b>
          </span>
        </div>

        <div className="ehsFormWrapper">
          <Row>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting ID</h5>
                <input
                  name="meetingID"
                  value={form?.scheduleId}
                  disabled
                  className="form-control"
                  placeholder="Meeting ID"
                />
                {/* <span className="small text-danger">{errorForm.meetingID}</span> */}
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Type</h5>
                <SelectSearch
                  disabled
                  options={events?.map((data) => ({
                    label: data.name,
                    value: data.id,
                  }))}
                  value={{
                    label: form?.name ? form?.name : form?.event?.name,
                  }}
                  onChange={({ label, value }) => {
                    setForm((prev) => ({
                      ...prev,
                      type: label,
                      eventId: value,
                    }));
                  }}
                />
                <span className="small text-danger">{errorForm.type}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Level</h5>
                <input
                  name="meetingLabel"
                  disabled
                  value={
                    form?.meetingLabel ? form?.meetingLabel : form?.event?.meetingLabel
                  }
                  //   disabled
                  className="form-control"
                  placeholder="Meeting Level"
                />

                <span className="small text-danger">{errorForm.meetingLabel}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Site Name</h5>
                <SelectSearch
                  options={sites.map((site) => ({
                    label: site.name,
                    value: site,
                  }))}
                  disabled={
                    form?.eventStatus == "planned" || IS_USER_SITE_MINES() ? true : false
                  }
                  value={{
                    label: form.site ? form.site.name : "",
                  }}
                  onChange={({ label, value }) => {
                    onChangeSite({ target: { site: value } });
                    setForm((prev) => ({
                      ...prev,
                      state: value?.state?.name,
                      country: value?.state?.country_master?.name,
                      siteName: value.name,
                      siteId: value.id,
                    }));
                  }}
                  // disabled={!!siteId}
                  name="siteName"
                />
                <span className="small text-danger">{errorForm.siteName}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Venue</h5>
                <input
                  name="venue"
                  value={form.venue}
                  onChange={onChange}
                  className="form-control"
                  readOnly={form?.eventStatus == "planned" ? true : false}
                  placeholder="Meeting Venue"
                  // disabled={form.venue ? true : false}
                />
                <span className="small text-danger">{errorForm.venue}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Date & Time</h5>
                <DatePicker
                  disabled={form?.eventStatus === MEETING_STATUS.planned ? true : false}
                  readOnly={form?.eventStatus === MEETING_STATUS.planned ? true : false}
                  name="date"
                  timeFormat={"HH:mm A"}
                  value={form.date ? form.date : moment().format("YYYY-MM-DD HH:mm")}
                  isValidDate={(m) =>
                    m.isAfter(new Date()) && disable12MonthAfterFutureDate(m)
                  }
                  onChange={onChangeDate}
                />
                <span className="small text-danger">{errorForm.date}</span>
              </div>
            </Col>
            <Col lg={12}>
              <div className="form-group viewbox">
                <div className="d-flex justify-content-between">
                  <h5 className="w-500 mb-1">Meeting Agenda (Brief) </h5>
                  <CustomTooltip tooltip="Meeting Agenda (Details)">
                    <span
                      className="icons font-20 text-cyanBlue"
                      onClick={() => setShowModal(true)}
                    >
                      <FiPlusCircle />
                      <FaInfo />
                    </span>
                  </CustomTooltip>
                </div>
                <textarea
                  name="agenda"
                  readOnly={form?.eventStatus === MEETING_STATUS.planned ? true : false}
                  value={form?.agenda}
                  className="form-control"
                  placeholder="Meeting Agenda (Brief)"
                  style={{ height: "88px" }}
                  onChange={({ target: { value } }) => {
                    setForm((prev) => ({
                      ...prev,
                      agenda: value,
                    }));
                  }}
                />

                <span className="small text-danger">{errorForm.agenda}</span>
              </div>
            </Col>

            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Reference Document Description</h5>
                <div className="d-flex">
                  <input
                    readOnly={form?.eventStatus == "planned" ? true : false}
                    name="refDocumentDescription"
                    value={form?.refDocumentDescription || ""}
                    className="form-control"
                    placeholder="Reference Document Description"
                    onChange={({ target: { value } }) =>
                      setForm((prev) => ({
                        ...prev,
                        refDocumentDescription: value,
                      }))
                    }
                  />
                  <span className="small text-danger">
                    {errorForm.refDocumentDescription}
                  </span>

                  <SingleFileUpload
                    clsName="form-group"
                    alias={false}
                    disabled={form?.eventStatus == "planned" ? true : false}
                    labelName=" "
                    selectedFile={form.insuranceFile}
                    deleteDocumentFile={() => onDeleteFile()}
                    onFileChange={(_event, responseData) => onChangeFile(responseData)}
                  />
                  <span className="small text-danger">{errorForm.insuranceFile}</span>
                </div>
              </div>
            </Col>
            {/* <Col lg={1}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Reference Document</h5>
                <SingleFileUpload
                  clsName="form-group"
                  alias={false}
                  disabled={form?.eventStatus == "planned" ? true : false}
                  labelName=" "
                  selectedFile={form.insuranceFile}
                  deleteDocumentFile={() => onDeleteFile()}
                  onFileChange={(_event, responseData) => onChangeFile(responseData)}
                />
                <span className="small text-danger">{errorForm.insuranceFile}</span>
              </div>
            </Col> */}
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Remarks</h5>
                <input
                  name="remarks"
                  value={form?.remarks || ""}
                  readOnly={form?.eventStatus == "planned" ? true : false}
                  className="form-control"
                  placeholder="Remakrs"
                  onChange={({ target: { value } }) =>
                    setForm((prev) => ({ ...prev, remarks: value }))
                  }
                />
                <span className="small text-danger">{errorForm.remarks}</span>
              </div>
            </Col>

            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Meeting Time Stamp</h5>
                <input
                  name="meetingTimeStamp"
                  value={form.actualDate}
                  disabled
                  className="form-control"
                  placeholder="Meeting Time Stamp"
                  onChange={({ target: { value } }) =>
                    setForm((prev) => ({ ...prev, actualDate: value }))
                  }
                />
                <span className="small text-danger">{errorForm.actualDate}</span>
              </div>
            </Col>

            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Previous Meeting Reference</h5>
                <input
                  readOnly={form?.eventStatus == "planned" ? true : false}
                  name="previousMeetingReference"
                  value={form?.previousMeetingReference}
                  onChange={({ target: { value, name } }) => {
                    setForm((prev) => ({
                      ...prev,
                      previousMeetingReference: value,
                    }));
                  }}
                  className="form-control"
                  placeholder="Previous Meeting Reference"
                />
                <span className="small text-danger">
                  {errorForm.previousMeetingReference}
                </span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Previous Meeting ID</h5>
                <SelectSearch
                  disabled={form?.eventStatus === MEETING_STATUS.planned ? true : false}
                  options={getSchedule?.map((meet) => ({
                    label: `${meet?.event?.name} - ${meet?.scheduleId}`,
                    value: meet?.id,
                    data: meet,
                  }))}
                  value={getSchedule
                    ?.map((meet) => ({
                      label: `${meet?.event?.name} - ${meet?.scheduleId}`,
                      value: meet?.id,
                      data: meet,
                    }))
                    .filter((d) => +d.value === form?.previousMeetingID)}
                  onChange={({ label, value, data }) => {
                    setForm((prev) => ({
                      ...prev,
                      previousMeetingID: value,
                      previewMeetingName: label,
                      previousMeeting: data,
                    }));
                  }}
                  init="Select Previous Meeting ID"
                />
                <span className="small text-danger">{errorForm.previousMeetingID}</span>
              </div>
            </Col>

            <Col lg={4}>
              {previousMeeting && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Views</Tooltip>}
                >
                  <Link
                    to={
                      (previousMeeting?.eventStatus === MEETING_STATUS.draft ||
                      previousMeeting?.eventStatus === MEETING_STATUS.planned
                        ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                        : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
                      previousMeeting?.id
                    }
                    className="icons  text-cyanBlue"
                    style={{
                      paddingTop: "26px",
                      display: "inline-block",
                    }}
                    target={"_blank"}
                  >
                    {/* <FiEye /> */}
                    <OverFlowLabel name={previousMeeting?.agenda} length={100} />
                  </Link>
                </OverlayTrigger>
              )}
            </Col>

            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Scheduler</h5>
                <input
                  name="scheduler"
                  value={
                    form?.scheduler
                      ? MeetingScheduler?.find((d) => d.key === form?.scheduler)?.name
                      : form?.event?.scheduler
                  }
                  disabled
                  className="form-control"
                  placeholder="Meeting ID"
                />
                <span className="small text-danger">{errorForm.scheduler}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Reviewer</h5>
                <input
                  name="scheduler"
                  value={
                    form?.event?.reviewer
                      ? MeetingReviewer?.find((d) => d.key === form?.reviewer)?.name
                      : "Not Applicable"
                  }
                  disabled
                  className="form-control"
                  placeholder="Meeting ID"
                />
                <span className="small text-danger">{errorForm.scheduler}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Approver</h5>
                <input
                  name="approver"
                  value={
                    form?.approver
                      ? MeetingApprover?.find((d) => d.key === form?.approver)?.name
                      : form?.event?.approver
                  }
                  disabled
                  className="form-control"
                  placeholder="Meeting ID"
                  onChange={({ target: { value } }) =>
                    setForm((prev) => ({ ...prev, approver: value }))
                  }
                />
                <span className="small text-danger">{errorForm.approver}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">Country</h5>
                <input
                  name="country"
                  value={form?.site?.state?.country_master?.name}
                  disabled
                  className="form-control"
                  placeholder="Country"
                />
                <span className="small text-danger">{errorForm.country}</span>
              </div>
            </Col>
            <Col lg={4}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">state</h5>
                <input
                  name="state"
                  value={form?.site?.state?.name}
                  disabled
                  className="form-control"
                  placeholder="State"
                />
                <span className="small text-danger">{errorForm.state}</span>
              </div>
            </Col>

            <Col lg={12}>
              <div className="form-group viewbox">
                <h5 className="w-500 mb-1">
                  {!id && groupParticipants.length > 0 ? "Additional " : ""}
                  Participants
                </h5>
                <div className="w-100">
                  <div className="table-responsive">
                    <table id="user_table" className="table table-bordered mb-3">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">Participant Category</th>
                          <th scope="col">Participant Name</th>
                          <th scope="col">Participant Email</th>
                          <th scope="col">Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {participants.length > 0 ? (
                          participants.map((x, index) => {
                            holdIndex = index + 1;
                            return x.deleted ? null : (
                              <tr key={index}>
                                <th>{holdIndex}</th>
                                <td>
                                  <SimpleSelect
                                    disabled={
                                      form?.eventStatus == "planned" ? true : false
                                    }
                                    name="category"
                                    value={x.category}
                                    onChange={(event) =>
                                      onChangeParticipant(event, index)
                                    }
                                    className="form-control"
                                    id="id"
                                    label="name"
                                    options={[
                                      { id: "Employee", name: "Employee" },
                                      {
                                        id: "contractorPerson",
                                        name: "Contractor",
                                      },
                                      { id: "Other", name: "Other" },
                                    ]}
                                    init="Select"
                                  ></SimpleSelect>

                                  <span className="small text-danger">
                                    {participantsErrors[index]?.category}
                                  </span>
                                </td>
                                <td>
                                  {x.category === "Employee" ? (
                                    <SelectSearch
                                      disabled={
                                        form?.eventStatus === "planned" ? true : false
                                      }
                                      options={employees
                                        ?.filter(
                                          (d) =>
                                            // d.currentWorkLocation ===
                                            //   LOGGED_IN_USER_SITE_ID() &&
                                            d.id !== LOGGED_IN_USER_EMPLOYEE_ID() &&
                                            d?.employmentStatus === "active"
                                        )
                                        ?.map((user) => ({
                                          label: employeeDropdownLabel(user),
                                          value: user,
                                        }))}
                                      value={{ label: x.name }}
                                      onChange={({ label, value }) => {
                                        onChangeParticipantName(
                                          {
                                            target: {
                                              name: label,
                                              email: value.email,
                                              userId: value.id,
                                            },
                                          },
                                          index
                                        );
                                      }}
                                    />
                                  ) : x.category === "contractorPerson" ? (
                                    <SelectSearch
                                      disabled={
                                        form?.eventStatus == "planned" ? true : false
                                      }
                                      options={contractorPersons
                                        ?.filter(
                                          (d) =>
                                            d.currentWorkLocation ===
                                              LOGGED_IN_USER_SITE_ID() &&
                                            d?.employmentStatus === "active"
                                        )
                                        .map((contractor) => ({
                                          label: `${contractor.firstName} ${contractor.lastName} ${contractor.middleName}`,
                                          value: contractor,
                                        }))}
                                      value={{ label: x.name }}
                                      onChange={({ label, value }) => {
                                        onChangeParticipantName(
                                          {
                                            target: {
                                              name: label,
                                              //email: value?.contractors?.email,
                                              email: "",
                                              userId: value?.id,
                                            },
                                          },
                                          index
                                        );
                                      }}
                                    />
                                  ) : (
                                    <input
                                      name="name"
                                      value={x.name}
                                      onChange={(event) =>
                                        onChangeParticipant(event, index)
                                      }
                                      type="text"
                                      className="form-control"
                                      disabled={
                                        form?.eventStatus == "planned" ? true : false
                                      }
                                    />
                                  )}

                                  <span className="small text-danger">
                                    {participantsErrors[index]?.name}
                                  </span>
                                </td>
                                <td>
                                  <input
                                    disabled={
                                      (!!x.userId && x.category === "Employee") ||
                                      form?.eventStatus == "planned"
                                    }
                                    name="email"
                                    value={x.email}
                                    onChange={(event) =>
                                      onChangeParticipant(event, index)
                                    }
                                    type="email"
                                    className="form-control"
                                  />
                                  <span className="small text-danger">
                                    {participantsErrors[index]?.email}
                                  </span>
                                </td>
                                <td>
                                  <div className="actionIconsGroup">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                                    >
                                      <span
                                        onClick={() => deleteRow(index)}
                                        className="pointer icons text-danger font-20"
                                      >
                                        <FiMinusCircle />
                                      </span>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" align="center">
                              {" "}
                              <span className="text-danger">
                                Add minimum two Participants
                              </span>
                            </td>
                          </tr>
                        )}
                        <tr>
                          {/* <td colSpan="10" align="left">
                    
                            {form?.participants?.length?"Add two Participants":""}
                          </td> */}
                        </tr>
                        <tr>
                          <td colSpan="10">
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                            >
                              <Button className="addRowPluseIcon" onClick={addRow}>
                                <FiPlusCircle />
                              </Button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {form?.eventStatus &&
          (form?.eventStatus !== MEETING_STATUS.draft || form?.isBack === 1) && (
            <div className="ehsFormWrapper">
              <Row>
                <Col lg={12} className="reviewerInputsComments">
                  <ViewComments
                    hideNotApplicable
                    title={"Workflow Inputs"}
                    comments={form?.incidentReviewsData || []}
                  />

                  <div className="addReviewerInput">
                    <textarea
                      class="form-control"
                      style={{ height: "88px" }}
                      name="reviewCompletionSummary"
                      onChange={onChange}
                      value={form.reviewCompletionSummary}
                      maxLength={500}
                      placeholder={`${
                        form?.vflAtLabel !== "so" ? "Mines Manager " : "Safety Officer "
                      } Input`}
                    />
                    {errorForm["reviewCompletionSummary"] && (
                      <InputError error={errorForm["reviewCompletionSummary"]} />
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          )}

        <div className="mb-2 text-center">
          <span
            className="btn pointer btn-secondary mr-2"
            onClick={() => history.goBack()}
          >
            Back
          </span>
          {form?.eventStatus !== "planned" ? (
            <Button
              type="submit"
              onClick={() => onSubmit("stay")}
              variant="primary"
              className="m-1 text-capitalize mr-2"
            >
              Save Draft
            </Button>
          ) : (
            <Decline
              onSubmit={(obj) => onSubmit("backward", obj)}
              title="Approve"
              name={
                <Button
                  type="submit"
                  variant="primary"
                  className="m-1 text-capitalize mr-2"
                >
                  Back to Scheduler
                </Button>
              }
              iconClass={"icons text-success"}
            />
          )}
          <Button
            type="submit"
            onClick={() => onSubmit("forward")}
            variant="primary"
            className="m-1 text-capitalize mr-2"
          >
            {form?.eventStatus
              ? form?.eventStatus !== "draft"
                ? "Approve"
                : "Submit for Approval"
              : "Submit for Approval"}
          </Button>
        </div>

        {loading && <NetZeroLoader addZIndex={true} />}

        <Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          backdrop="static"
          size="lg"
        >
          <div className="card" style={{ overflow: "visible" }}>
            <div className="card-body">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-1">Meeting Agenda (Details)</h3>
              </div>

              <Row className="mb-3">
                <Col
                  lg={12}
                  style={{
                    height: "500px",
                    overflow: "auto",
                  }}
                >
                  <div className="form-group viewbox">
                    {/* <h5 className="w-500 mb-1">Meeting Agenda (Brief)</h5> */}
                    {formDisabled ? (
                      <p dangerouslySetInnerHTML={{ __html: form?.detailedAgenda }}></p>
                    ) : (
                      <RichTextarea
                        name={"detailedAgenda"}
                        onChange={onChange}
                        value={form?.detailedAgenda}
                        disabled={
                          form?.eventStatus === MEETING_STATUS.planned ? true : false
                        }
                      />
                    )}
                    {/* <span className="small text-danger">{errorForm.agenda}</span> */}
                  </div>
                </Col>
              </Row>

              <div className="mt-2 text-center">
                <Button
                  onClick={() => {
                    setShowModal(false);
                  }}
                  className="btn btn-secondary mr-2"
                >
                  Save and Close
                </Button>
                {/* 
                <Button onClick={onSubmit} type="submit" variant="primary" className="m-1 text-capitalize">
                  Save
                </Button> */}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

const userRules = [
  {
    field_name: "meetingName",
    label: "Meeting Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "comment",
    label: "Describe Comment",
    type: "string",
    isRequired: false,
  },
  {
    field_name: "category",
    label: "Participant Category",
    type: "string",
    isRequired: true,
  },
];

const rules = [
  {
    field_name: "date",
    label: "Meeting Date & Time",
    type: "string",
    isRequired: true,
  },

  {
    field_name: "meetingID",
    label: "Meeting ID",
    type: "string",
    isRequired: false,
  },
  {
    field_name: "refDocumentDescription",
    label: "Reference Document Description",
    type: "string",
    isRequired: false,
  },
  {
    field_name: "remarks",
    label: "Remakrs",
    type: "string",
    isRequired: false,
  },
  {
    field_name: "venue",
    label: "Meeting Venue",
    type: "string",
    isRequired: true,
  },

  {
    field_name: "agenda",
    label: "Meeting Agenda (Brief)",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "siteName",
    label: "Site Name",
    type: "string",
    isRequired: true,
  },
  // {
  //   field_name: "previousMeetingReference",
  //   label: "Previous Meeting Reference",
  //   type: "string",
  //   // isRequired: false,
  // },
  // {
  //   field_name: "previousMeetingID",
  //   label: "Previous Meeting ID",
  //   type: "string",
  //   isRequired: false,
  // },
  // {
  //   field_name: "refDocumentDescriptionDescription",
  //   label: "Reference Document Description",
  //   type: "string",
  //   isRequired: false,
  // },

  {
    field_name: "meetingLabel",
    label: "Meeting Level",
    type: "string",
    isRequired: false,
  },
  {
    field_name: "meetingTimeStamp",
    label: "Meeting Time Stamp",
    type: "string",
    isRequired: false,
  },
  // {
  //   field_name: "scheduler",
  //   label: "Scheduler",
  //   type: "string",
  //   isRequired: false,
  // },
  // {
  //   field_name: "approver",
  //   label: "Approver",
  //   type: "string",
  //   isRequired: false,
  // },
  {
    field_name: "country",
    label: "Country",
    type: "string",
    isRequired: false,
  },
  {
    field_name: "state",
    label: "State",
    type: "string",
    isRequired: false,
  },
];

export default AddUpdateMeeting;
